"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 50.09 24",
    width: "50.09",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m49.3 0h-48.52a.78.78 0 0 0 -.78.78v22.44a.78.78 0 0 0 .78.78h48.52a.78.78 0 0 0 .79-.78v-22.44a.78.78 0 0 0 -.79-.78zm-40.43 22.43v-9.91h6.26v9.91zm39.65 0h-31.83v-10.69a.78.78 0 0 0 -.78-.78h-7.82a.78.78 0 0 0 -.79.78v10.69h-5.73v-20.86h47z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m21.39 13.37h9.13a.78.78 0 0 0 .78-.78v-3.66a.78.78 0 0 0 -.78-.78h-9.13a.78.78 0 0 0 -.78.78v3.66a.78.78 0 0 0 .78.78zm.78-3.65h7.57v2.08h-7.57z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m34.3 13.37h9.13a.78.78 0 0 0 .79-.78v-3.66a.78.78 0 0 0 -.79-.78h-9.13a.78.78 0 0 0 -.78.78v3.66a.78.78 0 0 0 .78.78zm.79-3.65h7.56v2.08h-7.56z"
  })));
};

exports["default"] = _default;